import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Bar from "../../../../../Component/Charts/Bar";
import config from "../config";

const { chartColors } = config;

const RejectedAndCancelledChecks = (props) => {
  const { data = [] } = props;
  const { t } = useTranslation();

  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [legends, setLegends] = useState([]);

  useEffect(() => {
    const kycRejected = data.find(
      (s) => s.check_type === "KYC" && s.check_status === "Rejected",
    );
    const amlRejected = data.find(
      (s) => s.check_type === "AML" && s.check_status === "Rejected",
    );
    const kycCancelled = data.find(
      (s) => s.check_type === "KYC" && s.check_status === "Incomplete",
    );
    const amlCancelled = data.find(
      (s) => s.check_type === "AML" && s.check_status === "Incomplete",
    );
    const kycExpired = data.find(
      (s) => s.check_type === "KYC" && s.check_status === "Expired",
    );
    const amlExpired = data.find(
      (s) => s.check_type === "AML" && s.check_status === "Expired",
    );
    const kycRejectedCount = kycRejected ? kycRejected.no_of_checks : 0;
    const amlRejectedCount = amlRejected ? amlRejected.no_of_checks : 0;
    const kycCancelledCount = kycCancelled ? kycCancelled.no_of_checks : 0;
    const amlCancelledCount = amlCancelled ? amlCancelled.no_of_checks : 0;
    const kycExpiredCount = kycExpired ? kycExpired.no_of_checks : 0;
    const amlExpiredCount = amlExpired ? amlExpired.no_of_checks : 0;

    setSeries([
      {
        name: "KYC",
        color: chartColors.checkColors.kyc,
        data: [kycExpiredCount, kycRejectedCount, kycCancelledCount],
      },
      {
        name: "AML",
        color: chartColors.checkColors.aml,
        data: [amlExpiredCount, amlRejectedCount, amlCancelledCount],
      },
    ]);
    setCategories([
      t(`labels.dashboard.rejectedAndCancelledChecks.expired`),
      t(`labels.dashboard.rejectedAndCancelledChecks.rejected`),
      t(`labels.dashboard.rejectedAndCancelledChecks.cancelled`),
    ]);
    setLegends([t(`labels.checks.KYC`), t(`labels.checks.AML`)]);
  }, [data]);

  return (
    <Bar
      series={series}
      categories={categories}
      legends={legends}
      title={t("labels.dashboard.rejectedAndCancelledChecks.title")}
      height={280}
    />
  );
};

export default RejectedAndCancelledChecks;
